// App.js
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "../src/components/layout";
import Home from "./components/pages/home";
import AboutUs from "./components/pages/aboutus"; // Import AboutUs component
import Loader from "./components/pages/loader";
import Services from "./components/pages/services";
import PackagesSection from "./components/pages/packages";
import ContactUs from "./components/pages/contactus";
import BrandsSection from "./components/pages/brand";
import PortfolioSection from "./components/pages/portfolio";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate website loading (you can replace with actual API or data load)
    const timer = setTimeout(() => {
      setLoading(false);
    }, 3000); // loader will show for 3 seconds
    return () => clearTimeout(timer);
  }, []);

  // Show loader while the site loads
  if (loading) {
    return <Loader />;
  }

  // Once loaded, show the website
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Header />}>
          <Route index element={<Home />} />
          <Route path="about" element={<AboutUs />} />
          <Route path="services" element={<Services />} />
          <Route path="packages" element={<PackagesSection />} />
           <Route path="reviews" element={<BrandsSection />} />
          <Route path="contact" element={<ContactUs />} /> 
          <Route path="portfolio" element={<PortfolioSection />} /> {/* Add About Us route */}
          {/* Add other routes below if needed */}
        </Route>
      </Routes>
    </Router>
  );
}

export default App;